import { trpc } from '@/lib/trpc';
import type { LandingBlock } from '../../../../shared/types/people-landing';

export function collectImageKeys(blocks: LandingBlock[] | undefined): string[] {
  if (!blocks) return [];
  const keys: string[] = [];
  for (const b of blocks) {
    if ('imageKey' in b && b.imageKey) keys.push(b.imageKey);
    if (b.type === 'cards') {
      for (const item of b.items) if (item.imageKey) keys.push(item.imageKey);
    }
    if (b.type === 'marquee') keys.push(...b.imageKeys);
  }
  return [...new Set(keys)];
}

/**
 * Presigned URLs de todas las imágenes de la página en batches de a 50
 * (límite del endpoint). staleTime 55min < 60min de vida del presigned
 * (patrón SkillAgentCard).
 */
export function useLandingImages(blocks: LandingBlock[] | undefined): Record<string, string> {
  const keys = collectImageKeys(blocks);
  const chunks: string[][] = [];
  for (let i = 0; i < keys.length; i += 50) chunks.push(keys.slice(i, i + 50));

  const results = trpc.useQueries((t) =>
    chunks.map((chunk) =>
      t.peopleLanding.getImageUrls({ keys: chunk }, { staleTime: 55 * 60 * 1000 })
    )
  );

  const urls: Record<string, string> = {};
  for (const r of results) {
    if (r.data?.urls) Object.assign(urls, r.data.urls);
  }
  return urls;
}
